<!-- Универсальный числовой шаг из snapshot шаблона. -->
<template>
  <VehicleInspectionStepLayout :title="step.name" :description="step.description">
    <div class="inspection-number-step__input">
      <BaseInput
        v-model="value"
        type="number"
        :min="step.code === 'odometer' ? 0 : undefined"
        :step="step.code === 'odometer' ? 1 : undefined"
      />
      <span v-if="step.code === 'odometer'" class="inspection-number-step__unit">км</span>
    </div>
    <template #actions>
      <base-primary-button
        size="large"
        :disabled="disabled || (isRequired && value === '') || (step.code === 'odometer' && !validOdometer)"
        @click="complete"
      >
        {{ !isRequired && value === "" ? "Пропустить" : "Дальше" }}
      </base-primary-button>
    </template>
  </VehicleInspectionStepLayout>
</template>

<script>
import VehicleInspectionStepLayout from "@/components/Vehicle/Inspection/Step/Layout.vue";

export default {
  name: "VehicleInspectionStepNumber",
  components: { VehicleInspectionStepLayout },
  props: {
    step: { type: Object, required: true },
    answer: { type: Object, default: null },
    disabled: { type: Boolean, default: false },
  },
  emits: ["complete"],
  data() {
    return { value: this.answer?.value?.value ?? "" };
  },
  computed: {
    isRequired() { return this.step.config?.required !== false; },
    validOdometer() { return this.value !== "" && this.value != null && Number.isInteger(Number(this.value)) && Number(this.value) >= 0; },
  },
  methods: {
    complete() {
      const value = this.value === "" ? {} : { value: Number(this.value) };
      this.$emit("complete", { value });
    },
  },
};
</script>

<style scoped>
.inspection-number-step__input {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 12px;
}

.inspection-number-step__unit {
  color: color-mix(in srgb, var(--color-dark) 78%, var(--color-light));
  font-size: 16px;
  font-weight: 500;
}
</style>
